export interface LoadedImage {
  element: HTMLImageElement;
  dataUrl: string;
  filename: string;
}

export async function loadImageFile(file: File): Promise<LoadedImage> {
  if (!file.type.startsWith("image/")) {
    throw new Error("Choose a JPG, PNG, WEBP, HEIC-compatible, or other browser-readable image.");
  }

  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("The image could not be read."));
    reader.onload = () => resolve(String(reader.result));
    reader.readAsDataURL(file);
  });

  const element = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () =>
      reject(
        new Error(
          "The browser could not decode this image. Convert HEIC files to JPG first if necessary.",
        ),
      );
    image.src = dataUrl;
  });

  return {
    element,
    dataUrl,
    filename: file.name.replace(/\.[^.]+$/, ""),
  };
}
